import SignUpQrCode from 'components/SignUpQrCode';
import useMixpanel from 'hooks/useMixpanel';
import Branding from 'pages/login/Branding';
import React, { useEffect } from 'react';
import {
  Content,
  Layout,
  SignUp,
  SignUpSubtitle,
  SignUpText,
  SignUpTitle,
} from './styles';

interface CompleteOnMobileProps {
  showBranding?: boolean;
  titleContent?: string;
}

const CompleteOnMobileContent = ({ titleContent }: CompleteOnMobileProps) => (
  <Layout>
    <Content style={{ textAlign: 'center' }}>
      <SignUp large>
        <SignUpText large>
          <SignUpTitle large>
            {titleContent ?? 'New to Exos? Sign up'}
          </SignUpTitle>
          <SignUpSubtitle large>
            Finish creating your account by scanning the QR code below or
            opening the Exos app on your mobile device.
          </SignUpSubtitle>
        </SignUpText>
        <SignUpQrCode size={200} />
      </SignUp>
    </Content>
  </Layout>
);

export const CompleteOnMobile = ({
  showBranding = true,
  titleContent,
}: CompleteOnMobileProps) => {
  const track = useMixpanel();

  useEffect(() => {
    track('Screen View', {
      screen_name: 'qr_code_to_complete_enrollment_in_app',
    });
  }, [track]);

  if (!showBranding) {
    return <CompleteOnMobileContent titleContent={titleContent} />;
  } else {
    return (
      <Branding>
        <CompleteOnMobileContent titleContent={titleContent} />
      </Branding>
    );
  }
};
